import { useEffect, type ReactNode } from 'react';
import isMobile from 'is-mobile';
import { useScrollLock } from '@shared/hooks';
import { cn } from '@shared/utils';
import { Button } from '@shared/widgets';
import CloseIcon from '@assets/images/contact/close.svg';

interface PdfViewerProps {
  open: boolean;
  onClose: () => void;
  className?: string;
  title?: ReactNode;
  data: string;
}

export const PdfViewer = (props: PdfViewerProps) => {
  const mobile = isMobile();

  const { lock, unlock } = useScrollLock();
  useEffect(() => {
    props.open ? lock() : unlock();
    return () => unlock();
  }, [props.open]);

  useEffect(() => {
    if (!props.open || !mobile || !props.data) return;
    window.open(props.data, '_blank', 'noopener,noreferrer');
    props.onClose();
  }, [props.open, mobile, props.data]);

  if (!props.open || mobile) return;
  return (
    <div className={cn('fixed top-0 right-0 bottom-0 left-0 z-10 flex items-center justify-center bg-[#00000099]', props.className)}>
      <div
        className={cn(
          'relative right-10 bottom-0 m-auto flex h-full w-150 flex-col rounded-2xl',
          'max-md:absolute max-md:inset-4 max-md:flex max-md:w-auto max-md:overflow-y-auto',
          'not-max-md:justify-center',
        )}
      >
        <header className='flex justify-between rounded-t-2xl bg-[#272727] p-4'>
          <h3 className='text-[#e5c496] uppercase'>{props.title}</h3>
          <i className='ml-2 flex cursor-pointer items-center' onClick={props.onClose}>
            <CloseIcon />
          </i>
        </header>
        <main className='rounded-b-2xl bg-white px-4 pb-4'>
          <iframe title='pdf' src={props.data} width='100%' height={550} />
          <Button className='mt-5 ml-auto w-39.75' onClick={props.onClose}>
            Ok
          </Button>
        </main>
      </div>
    </div>
  );
};
